import Vue from 'vue'
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import router from '@/routes//routes.js'
import cloneDeep from "lodash.clonedeep";
//import merge from "lodash.merge";
import filter from "lodash.filter";
import axios from "axios";

Vue.use(Vuex);

import { flattenModel } from '@/helpers/answerHelper.js';

const store_state = function(){
    return {
        answers: {},
        labels: {},
        schema: [],
        activeStepKey: null,
        stepPath: [],
        backendData: {},
        schema_hash: '',
        schema_version: 0,
        loading: false,
    }
}

function recursive_flatten(xs) {
    if (Array.isArray(xs)) {
        return xs.reduce((acc, x) => {
            acc = acc.concat(x);
            if (x.children) {
            acc = acc.concat(recursive_flatten(x.children));
            x.children = [];
            }
            return acc;
        }, []);
    } else {
        return xs;
    }
}

const api = {
    url: '/', // process.env.NODE_ENV === 'production' ? '/' : process.env.VUE_APP_API_URL, //
    version: 'api/v1/'
}

const schema_location_url = `${api.url}assets/schema/`;


const store = new Vuex.Store({
    state: {
        session_id: null,
        stripe: null,
        client: null, // Hard to know if should be null or {} - null means not set, but breaks calling client.cli_num early :O
        sessions: {},
        pageLoading: false,
        appConfig: {},
    },
    actions: {
        getUUID(store) {
            // console.log('store getUUID');
            return new Promise((resolve, reject) => {

                // Load in client data
                store.dispatch('getClientData',{ forceRefresh: true })
                .then(_ => {
                    axios
                    .get(api.url + api.version + 'vehicle/create-uuid')
                    .then(res => {
                        const data = res.data;
                        // console.log(data);
                        if (res.data.results.valid) {
                            // console.log('valid resolved UUID');
                            // console.log(data);

                            store.commit('initSession',data.results.uuid);
                            store.commit('initSchemaHash',data.schema_current_hash);
                            store.commit('initSchemaVersion',data.schema_current_version);

                            resolve(data.results.uuid);
                        } else {
                            // console.log('error getting UUID', data.results.error);
                            reject(data.results.error);
                        }
                    })
                    .catch(error => {
                        console.error(error.response, "will handle status.403 - To Review");
                        if( error.response && error.response.status === 403 ){
                            reject('login_required');
                        }
                        reject(error.message);
                    });
                })
                .catch(error => {
                    console.error(error, "Error saving UUID to store");
                });
            })
        },
        getPlate(store, payload) {
            // console.log('store getPlate');
            return new Promise((resolve, reject) => {
                const plate = payload.plate;

                // If the plate hasn't changed from the last plate validation lookup, just skip the step
                if (store.getters.flattenedAnswers[store.getters.getStep('plate')] && store.getters.flattenedAnswers[store.getters.getStep('plate')].vehicle_plate_confirm == plate) {
                    // no action required
                    // console.log('no lookup required');
                    resolve();
                } else {

                    // Additional code to handle different payment intervals for testing
                    // See API plate controller for details
                    let params = {
                        recaptcha_token: payload.recaptcha_token
                    };

                    if( router.currentRoute.query && router.currentRoute.query.payment_interval){
                        // console.warn('router test', router.currentRoute.query );
                        params.payment_interval = router.currentRoute.query.payment_interval;
                        // console.warn('router params', payment_interval_query_params );
                    }


                    axios.post(
                        api.url + api.version + 'vehicle/plate/' + plate + '/' + store.state.session_id,
                        params
                    )
                    .then(response => {
                        if ( response.data && response.data.results && response.data.results.valid ) {
                            // console.log(data);
                            store.commit('updateBackendData', {
                            [store.getters.getStep('plate')]: {
                                vehicle_make: response.data.results.vehicle.make,
                                vehicle_model: response.data.results.vehicle.model,
                                vehicle_year: response.data.results.vehicle.year,
                                vehicle_price_low: response.data.results.vehicle.price_low,
                                vehicle_price_high: response.data.results.vehicle.price_high,
                                vehicle_price_avg: response.data.results.vehicle.price_avg,
                                vehicle_plate_confirm: response.data.results.vehicle.plate
                            }
                            });

                            resolve();
                        } else {
                            // Turning this console error ( which bumps to Sentry off )
                            // console.error("Store GetPlate error", response.data.results.error);
                            reject(response.data.results.error);
                        }
                    })
                    .catch(error => {
                        // session timeout
                        console.error(error, "Session Timeout");
                        reject( error );
                    });
                }
            })
        },

        getSchema(store, schema_file) {
            return new Promise((resolve, reject) => {

                axios.get(
                    api.url + api.version + 'schema/vehicle/' + schema_file + '/' + store.getters.currentSession.schema_version,
                    {
                        responseType: 'json'
                    }
                )
                .then(response => {
                    
                    if ( response.data.results && !response.data.error ) {                        
                        // console.log('resolved');
                        resolve(response.data.results);
                    } else {

                        // console.log(response);
                        // console.log(response.data.error);

                        // globally redirect on schema fail
                        if ( response.data && response.data.redirect ) {
                            window.location = response.data.redirect;
                        } else {
                            console.error('Error from API, but no redirect set');
                        }

                        reject(response.data);
                    }
                })
            })
        },

        // Get the Stripe public key, used for Stripe Elements
        async getStripeKey({ commit, state }, products) {
            try {
                const response = await axios.get(api.url + api.version + 'stripe/public-key');
                state.stripe = Stripe(response.data.results.key);
            } catch (e) {
                console.error(`Could not get Stripe key`, e);
                // TODO - this should show an error state to the client
            }
        },

        // Get the Client Data (includes billing data if it exists )
        // Note - can also be called on newBiz MakePayment Success if they are a new client signing up
        async getClientData({ commit, state }, options = {}) {

            if ( options.forceRefresh || !state.client ) {

                // console.warn('getClientData ajaxed');

                try {
                    let client_query_params = '';
                    if( router.currentRoute.query && router.currentRoute.query.force_cli_num){
                        client_query_params = `?force_cli_num=${router.currentRoute.query.force_cli_num}`;
                    }
                    const response = await axios.get(`${api.url}${api.version}client/get-client-by-session${client_query_params}`);
                    if( response.data.results && response.data.results.client  ){
                        state.client = response.data.results.client;
                        Vue.set( state.client, 'billing', response.data.results.client.billing );
                    } else {
                        throw new Error('There was a problem loading client session.');
                    }
                } catch (e) {
                    console.error(`Could not get client data`, e);
                    // TODO - this should show an error state to the client
                }
            }
        },
    },
    mutations: {
        setPageLoading(state, loading) {
            state.pageLoading = loading;
        },
        initSession(state, session_id) {
            // console.log('initSession')
            state.session_id = session_id;

            // new empty session
            if ( !state.sessions[session_id] ) {
                Vue.set( state.sessions, session_id, store_state() );
            }
        },
        initSchemaHash(state, hash) {
            // console.log('initSchemaHash');

            state.sessions[state.session_id].schema_hash = hash;
        },
        initSchemaVersion(state, version) {
            // console.log('initSchemaVersion');

            state.sessions[state.session_id].schema_version = version;
        },
        updateAnswers(state, payload) {

            // Vue.set( state.sessions[state.session_id].answers,
            //          payload.localActiveStep,
            //          merge( state.sessions[state.session_id].answers[payload.localActiveStep], payload.answers )
            //        );

            Vue.set( state.sessions[state.session_id].answers, payload.localActiveStep, payload.answers );
            

            // set an empty object for each step
            Vue.set( state.sessions[state.session_id].labels, payload.localActiveStep, {} );


            // console.warn( state.sessions[state.session_id].schema );
            let schema = cloneDeep(state.sessions[state.session_id].schema);
            let flattenedSchema = recursive_flatten( schema );

            // we can set the labels for the answers here too
            for ( const [key, value] of Object.entries(store.getters.flattenedAnswers[payload.localActiveStep]) ) {
                // find key from schema, and associated options

                //const target = (filter( flattenDeep( state.sessions[state.session_id].schema ), { 'name': key } )[0]);

                // console.warn(key);
                const target = (filter(flattenedSchema,{'name': key})[0]);
                // console.warn(target);

                if ( target && target.options ) {

                    let options = target.options;
                    // if we have options
                    if (Array.isArray(options)) {
                        options.forEach(option => {
                            if (value == option.value) {
                                // option matches what was selected, save this label as the result in the store
                                Vue.set( state.sessions[state.session_id].labels[payload.localActiveStep], key, option.label )
                            }
                        });
                    }

                } else if (target) {
                    Vue.set( state.sessions[state.session_id].labels[payload.localActiveStep], key, target.label );
                }
            }
        },
        setAnswer(state, payload) {
            if ( !payload.step || !payload.answer || !payload.value ) {
                console.error('trying to setAnswer, but missing data - payload:', payload);
                return false;
                // explode here
            }

            // check for object
            if ( typeof(payload.value) === 'object' ) {
                // handle setting this differently,

                // we don't want to clobber other keys in an array when setting values
                // new answer object:
                // { replacement_key: new_value }
                // existing answer object:
                // { important_key: value, another_key: value, replacement_key: old_value }

                if ( typeof state.sessions[state.session_id].answers[payload.step][payload.answer] !== 'undefined' ) {
                    // check this answer exists
                    Vue.set(
                        state.sessions[state.session_id].answers[payload.step],
                        payload.answer,
                        // merge new value with old
                        [{ ...state.sessions[state.session_id].answers[payload.step][payload.answer][0], ...payload.value }]
                    );
                } else {
                    // just set it directly
                    Vue.set(
                        state.sessions[state.session_id].answers[payload.step],
                        payload.answer,
                        [ payload.value ]
                    );
                }
            } else {
                // answer = value

                if ( state.sessions[state.session_id].answers[payload.step] === undefined ) {
                    // we may need to set the step up first
                    // (this is needed for email restore, attempting to set answers for steps we've not navigated to)
                    Vue.set( state.sessions[state.session_id].answers, payload.step, Object() );
                }

                Vue.set( state.sessions[state.session_id].answers[payload.step], payload.answer, payload.value );
            }
        },
        updateSchema(state, payload) {
            Vue.set( state.sessions[state.session_id], 'schema', payload );
        },
        setActiveStep(state, stepKey){
            state.sessions[state.session_id].activeStepKey = stepKey;
            if( !state.sessions[state.session_id].answers[stepKey] ){
                Vue.set( state.sessions[state.session_id].answers, stepKey, {} );
            }
        },
        updateBackendData(state, payload) {
            state.sessions[state.session_id].backendData = {...state.sessions[state.session_id].backendData, ...payload};
        },
        setDriver(state, payload){
            // console.warn('setDriver: ', payload);

            // switching between drivers, unset any answers for previous driver that we've previously added to answers / backendData
            if (state.client.selectedDriver) {
                // loop over every driver to find selectedDriver
                (state.client.drivers).forEach(function(driver){
                    if (state.client.selectedDriver == driver.driver_id) {
                        // loop through previously selected driver and unset all underwriting and backend answers specific to that driver

                        for (const [backendStep, answers] of Object.entries(driver.backend)) {
                            for (const [answerKey, answer] of Object.entries(answers)) {
                                if (state.sessions[state.session_id].backendData[backendStep][answerKey] == answer) {
                                    Vue.delete(state.sessions[state.session_id].backendData[backendStep], answerKey);
                                }
                            }
                        }

                        for (const [answerStep, answers] of Object.entries(driver.underwriting_answers)) {
                            for (const [answerKey, answer] of Object.entries(answers)) {
                                if (state.sessions[state.session_id].answers[answerStep][answerKey] == answer) {
                                    Vue.delete(state.sessions[state.session_id].answers[answerStep], answerKey);
                                }
                            }
                        }
                    
                        // exit loop
                        return false;
                    }
                })
            }
            
            if (payload == 'new-driver') {
                // unset selectedDriver, since we aren't selecting one
                Vue.delete( state.client, 'selectedDriver' );
            } else {

                // set selectedDriver and all answers for driver
                // Note 'underwriting_answers' is populated from the backend
                (state.client.drivers).forEach(function(driver){

                    if (payload == driver.driver_id) {

                        // save provided answers in backend
                        store.commit('updateBackendData', cloneDeep(driver.backend) );

                        if ( !driver.underwriting_answers) {
                            throw new Error('driver underwriting answers were not set');
                        }

                        console.log(driver.underwriting_answers);

                        // loop over driver.answers
                        for (const [answerStep, answers] of Object.entries(driver.underwriting_answers)) {
                            store.commit('updateAnswers',
                                {
                                    'localActiveStep': answerStep, 'answers': cloneDeep(answers)
                                }
                            );
                        }

                        // store currently selected driver id
                        Vue.set( state.client, 'selectedDriver', payload );
                    
                        // exit loop
                        return false;
                    }
                })
            }
        },
        updateAppConfig(state, payload){
            state.appConfig = {...state.appConfig,...payload};
        }
    },
    getters: {
        getStep: state => (step) => {

            // handles 'Vehicle.Confirm' / 'VehicleAlt.confirm' / 'confirm'
            // and returns the current route
            // ie. while in Vehicle Alt => 'Vehicle.Confirm' becomes 'VehicleAlt.Confirm'
            //                         and 'confirm'         becomes 'VehicleAlt.Confirm'
            // makes sure to always get the answers regardless of route
            // (this means shared components can be agnostic about where answers are stored)

            let justStep = step;

            if (step.indexOf('.') > -1) {
                justStep = step.split(".")[1];
            }

            // regex to convert under_score to CamelCase, leaves existing CamelCase alone
            let toCamelCase = (str) => str.replace(/(?:^\w|[A-Z]|\b\w|[_]\w)/g, (ltr, idx) => ltr.toUpperCase()).replace(/\s|[_]+/g, '');

            // do it
            justStep = toCamelCase(justStep);

            return router.currentRoute.name.split(".")[0] + "." + justStep;
        },
        isAltFlow: (state, getters) => {
            return getters.getStep('') == 'VehicleAlt.'
        },
        isRenewFlow: (state, getters) => {
            return getters.getStep('') == 'VehicleRenew.'
        },
        stripe: state => {
            return state.stripe;
        },
        client: state => {
            return state.client;
        },
        isLoggedIn: state => {
          return state.client && state.client.cli_num
        },
        currentSession: state => {
            if (!state.session_id) {
                // router.push('/fail');
                return false;
            }
            return state.sessions[state.session_id];
        },
        envIsProd: state => {
            return state.appConfig._env_is_prod
        },
        envNotProd: state => {
            return ! state.appConfig._env_is_prod
        },
        envIsLocal: state => {
            return state.appConfig._env === 'local'
        },
        env: state => {
            return state.appConfig._env
        },
        getAppConfig: state => {
            return state.appConfig
        },
        getResellerLogoUrl: state => {
            return state.appConfig.reseller_logo_url ?? null
        },
        // flattenedAnswers lets us easily lookup a value from a field without managing how far its nested within a group from a page
        flattenedAnswers: state => {

            // console.warn( router.currentRoute.name.split(".")[0] );

            let flattenedAnswers = {};
            for (let panel in state.sessions[state.session_id].answers) {

                // Check for nulls to prevent breaking the whole app if there is the data somehow has something weird in it
                if (state.sessions[state.session_id].answers[panel] && state.sessions[state.session_id].answers[panel] !== null) {
                    flattenedAnswers[panel] = {...flattenedAnswers[panel], ...flattenModel(state.sessions[state.session_id].answers[panel])};
                }

                if (state.sessions[state.session_id].backendData && state.sessions[state.session_id].backendData[panel] && (state.sessions[state.session_id].backendData[panel] !== null) ) {
                    flattenedAnswers[panel] = {...flattenedAnswers[panel], ...flattenModel(state.sessions[state.session_id].backendData[panel])};
                }
            }

            return flattenedAnswers;
        },
        getAnswer: (state) => (step, answerKey) => {
            if (!state.session_id) {
                // router.push('/fail');
                return '';
            }

            // translate Vehicle.Confirm into VehicleAlt.Confirm if required
            let realStep = store.getters.getStep(step);

            let flattenedAnswers = store.getters.flattenedAnswers;

            if (realStep in flattenedAnswers) {
                if (answerKey in flattenedAnswers[realStep]) {
                    return flattenedAnswers[realStep][answerKey];
                } else {
                    // router.push('/fail');
                    return '';
                }
            } else {
                // router.push('/fail');
                return '';
            }
        },
        getAnswerLabel: (state) => (step, answerKey) => {
            if (!state.session_id) {
                return false;
            }

            let realStep = store.getters.getStep(step);

            if (realStep in state.sessions[state.session_id].labels) {
                if (answerKey in state.sessions[state.session_id].labels[realStep]) {
                    return state.sessions[state.session_id].labels[realStep][answerKey];
                } else {
                    return store.getters.flattenedAnswers[realStep][answerKey];
                    // return store.getters.getAnswer(realStep, answerKey);
                }
            } else {
                return store.getters.flattenedAnswers[realStep][answerKey];
                // return store.getters.getAnswer(realStep, answerKey);
            }
        },
        getSessionId: (state) => () => {
            return state.session_id;
        },
        getSessionSchemaHash: (state) => () => {
            // console.log('get schema hash');
            return state.sessions[state.session_id].schema_hash
        },
        getDriver: state => {
            // get driver id if set, otherwise get from form inputs

            // console.log( 'getDriver' );
            // console.log( JSON.parse(JSON.stringify(store.getters.flattenedAnswers['Vehicle.Confirm']) ) );

            if ( store.getters.flattenedAnswers[store.getters.getStep('confirm')]['vehicle_confirm_driver'] ) {

                if ( store.getters.flattenedAnswers[store.getters.getStep('confirm')]['vehicle_confirm_driver'] === 'new-driver' ) {
                    // new driver

                    let result = {};

                    if ( store.getters.flattenedAnswers[store.getters.getStep('driverdetails')] && store.getters.flattenedAnswers[store.getters.getStep('driverdetails')]['driver_details_first_name'] ) {
                        result.first_name = store.getters.flattenedAnswers[store.getters.getStep('driverdetails')]['driver_details_first_name'];
                    } else {
                        result.first_name = false;
                    }

                    if ( store.getters.flattenedAnswers[store.getters.getStep('driverdetails')] && store.getters.flattenedAnswers[store.getters.getStep('driverdetails')]['driver_details_last_name'] ) {
                        result.last_name = store.getters.flattenedAnswers[store.getters.getStep('driverdetails')]['driver_details_last_name']
                    } else {
                        result.last_name = false;
                    }

                    if ( store.getters.flattenedAnswers[store.getters.getStep('confirm')] && store.getters.flattenedAnswers[store.getters.getStep('confirm')]['vehicle_confirm_driver_dob'] ) {
                        result.dob = store.getters.flattenedAnswers[store.getters.getStep('confirm')]['vehicle_confirm_driver_dob']
                    } else {
                        result.dob = false;
                    }
                    
                    return result;
                } else {
                    // existing driver

                    let driver_id = parseInt( store.getters.flattenedAnswers[store.getters.getStep('confirm')]['vehicle_confirm_driver'] );

                    // the drivers should already be set by an ajax call handled by
                    // the stores mutation 'getClientData' (in main.js)
                    if ( state.client && 'drivers' in state.client && driver_id ) {

                        // loop through drivers, find match
                        for (let i = 0; i < state.client.drivers.length; i++) {
                            if ( driver_id == state.client.drivers[i].driver_id ) {
                                return {
                                    'first_name': state.client.drivers[i].first_name ?? false,
                                    'last_name': state.client.drivers[i].last_name ?? false,
                                    'dob': state.client.drivers[i].dob ?? false
                                };
                            }
                        }
                    }
                }
            }
            return false;
        },
        getPaymentInterval: (state) => (formatted) => {

            // sometimes this getter is run when payment_interval has not yet been
            if (typeof store.getters.flattenedAnswers[store.getters.getStep('quote')].payment_interval === 'undefined') {
                return null
            }
            
            if (formatted) {
                // formats for front-end monthly to Monthly, yearly to Yearly
                return store.getters.flattenedAnswers[store.getters.getStep('quote')].payment_interval[0].toUpperCase() +
                    store.getters.flattenedAnswers[store.getters.getStep('quote')].payment_interval.slice(1);
            } else {
                return store.getters.flattenedAnswers[store.getters.getStep('quote')].payment_interval;
            }
        }
    },
    plugins: [
        createPersistedState({
            // paths: ['answers','backendData','activeStepKey','stepPath']
            paths: ['sessions','client']
        })
    ],
});


export default store;
export { api };
export { schema_location_url };
